import { Box, useTheme } from "@mui/material";
import { ASTableV2Cell } from "@qubit/autoparts";

import { useGetMultiTempGridInfo } from "~/hooks/useGetMultiTempGridInfo";

import { parseProductTempZone, tempZoneIconMap } from "~/lib/tempZone";

type Props = {
  tempZone?: string | null;
};

export function TemperatureZoneBadgeCell({ tempZone }: Props) {
  const { palette } = useTheme();
  const { isMultiTempGrid } = useGetMultiTempGridInfo();
  const parsedTempZone = parseProductTempZone(tempZone);

  // If not multi-temp grid, don't render anything
  if (!isMultiTempGrid) {
    return null;
  }

  // If multi-temp grid but no valid zone, render empty cell
  if (parsedTempZone === null) {
    return (
      <ASTableV2Cell
        aria-label="empty temperature zone"
        sx={{
          width: "28px",
          padding: "0 !important"
        }}
      />
    );
  }

  // Render the temperature zone badge
  const Icon = tempZoneIconMap[parsedTempZone];
  const bgColor = palette[parsedTempZone].main;

  return (
    <ASTableV2Cell
      aria-label={`${parsedTempZone} temperature zone`}
      sx={{
        padding: "0 !important",
        overflow: "hidden",
        width: "28px",
        backgroundColor: `${bgColor} !important`
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "center",
          width: "100%",
          height: "100%",
          pb: 2,
          pr: 0.75
        }}
      >
        <Icon width={20} height={20} />
      </Box>
    </ASTableV2Cell>
  );
}
